<template>
  <WsUpdate
    :modelName="modelName"
    :modelVersionName="modelVersionName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    editType="createVersion"
    titleKey="last_version.name"
    :hasBindOther="hasBindOther"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/risk_template";
export default {
  data: () => ({
    modelName: model.modelName,
    modelVersionName: `${model.modelName}_version`,
    label: model.label,
    fields: model.fields,
    hasBindOther: true,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "風險評估資訊",
              fields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "area",
                "area_section",
                "system_class",
                "system_subclass",
              ],
            },
          ],
        },
      ],
    },
  }),
};
</script>